import React from "react";
import FilterGroup from "../../common/reports/FilterGroup";
import FilterItem from "../../common/reports/FilterItem";
import Button from "../../framework/Button";
import Shortcut from "../../framework/Shortcut";
import classes from "./CacUserSummary.module.css";

const CacUserSummary = ({
  showAutoComplete = () => {},
  quickExport = () => {},
  refreshData = () => {},
  refreshRef,
  addRef,
}) => {
  return (
    <div className={classes["summary-container"]}>
      <div className={classes["summary-ctas"]}>
        <FilterGroup>
        <FilterItem>
            <Button
              label="Quick Export"
              color="black"
              onClick={quickExport}
              endIcon={<Shortcut keys={["Alt", "E"]} />}
            />
          </FilterItem>
          <FilterItem>
            <Button
              ref={refreshRef}
              label="Refresh"
              color="black"
              onClick={() => {
                refreshData();
              }}
              endIcon={<Shortcut keys={["Alt", "R"]} />}
            />
          </FilterItem>
          <FilterItem>
            <Button
              ref={addRef}
              label="Add New User"
              color="violet"
              onClick={showAutoComplete}
              endIcon={<Shortcut keys={["Ctrl", "U"]} />}
            />
          </FilterItem>
        </FilterGroup>
      </div>
    </div>
  );
};

export default CacUserSummary;
